import React from 'react';
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  FunctionField,
  BooleanField,
  BooleanInput,
  EditButton,
  DisabledInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

import PolarityField from './ui/PolarityField';
import ListFilter from './ui/ListFilter';
import FacebookImage from './ui/FacebookImage';
import tags from '../config/tags';

export const FacebookPagesList = props => (
  <List title="Facebook Pages" {...props} filters={<ListFilter />}>
    <Datagrid>
      <FacebookImage label="Profile picture" source="id" sortable={false} />
      <TextField source="id" sortable={false} />
      <FunctionField
        source="id"
        label="Name"
        render={record => (
          <a href={'https://facebook.com/' + record['id']} target="_blank" rel="noopener noreferrer">
            {' '}
            {record.name}
          </a>
        )}
      />
      <TextField label="fans" source="activities.fans" />
      <TextField label="talking" source="activities.talking" />
      <PolarityField label="Polarity" source="tag" />
      <BooleanField source="active" />
      <EditButton label="" />
    </Datagrid>
  </List>
);

const SiteName = ({ record }) => {
  return <span>Facebook Page {record ? `"${record.name}"` : ''}</span>;
};

export const FacebookPageEdit = props => (
  <Edit title={<SiteName />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <TextInput source="name" />
      <SelectInput source="tag.ref" label="Polarity" allowEmpty={true} choices={tags} optionValue="ref" />
      <BooleanInput source="active" />
    </SimpleForm>
  </Edit>
);

export const FacebookPageCreate = props => (
  <Create title="Create Facebook Page" {...props}>
    <SimpleForm>
      <TextInput source="id" />
      <TextInput source="name" />
      <SelectInput source="tag.ref" label="Polarity" allowEmpty={true} choices={tags} optionValue="ref" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/facebookpages.js